package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_qbauth_data_di_QbAuthModule : Module get() = module {
	single() { _ -> com.essntl.features.qbauth.data.repository.QbAuthRepositoryImpl(supabase=get()) } bind(com.essntl.features.qbauth.domain.repository.QbAuthRepository::class)
	single() { _ -> com.essntl.features.qbauth.data.supabase.QbAuthSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.qbauth.data.supabase.QbAuthSupabaseDataSource::class)
}
public val com.essntl.features.qbauth.data.di.QbAuthModule.module : org.koin.core.module.Module get() = com_essntl_features_qbauth_data_di_QbAuthModule
